<ion-app>
  @if (!remoteConfigReady() || !availability.isReady()) {
  <div class="app-loading"></div>
  } @else if (forceUpdateRequired()) {
  <app-force-update [message]="updateMessage()" [storeUrl]="storeUrl()">
  </app-force-update>
  } @else if (availability.mode() === 'OFFLINE') {
  <main class="maintenance-page">
    <section class="maintenance-panel">
      <h1>Maintenance in progress</h1>
      <p>{{ availability.message() }}</p>
    </section>
  </main>
  } @else {

  @if (availability.mode() === 'READ_ONLY') {
  <div class="maintenance-banner">
    {{ availability.message() }}
  </div>
  }

  @if (notificationService.notificationsDenied() && !notificationBannerDismissed()) {
  <div class="notification-denied-banner">
    Notifications are blocked. To re-enable: click the tune icon next to the URL &rarr; Site permissions &rarr; Notifications &rarr; Allow.
    <button class="notification-denied-close" (click)="dismissNotificationBanner()" aria-label="Dismiss">&#x2715;</button>
  </div>
  }

  <ion-router-outlet id="root-router-outlet"></ion-router-outlet>

  }
</ion-app>
